import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-auto',
  templateUrl: './video-auto.component.html',
  styleUrls: ['./video-auto.component.css']
})
export class VideoAutoComponent implements OnInit {

  @Input() videoAuto_params: any = {}
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    console.log(this.videoAuto_params.videoURL);
    this.videoAuto_params.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoAuto_params.videoURL);
    console.log(this.videoAuto_params.urlVideoSafe);
  }

}
